module.exports = __webpack_public_path__ + "static/media/schools.5a0b46f2.jpg";